import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Info from '@/views/Info'
import Terms from '@/views/Info/Terms'
import Privacy from '@/views/Info/Privacy'
import UserProfile from '@/views/Info/Profile'
import RadarCreator from '../views/RadarCreator'
// import Radar from "./Pages/Radar";
// import RadarView from "./components/radar/RadarView";

const Dashboard = () => import('@/views/Dashboard')
const Radar = () => import('@/views/Radar')
const Admin = () => import('@/views/Admin');
const AdminUserList = () => import('@/views/Admin/UserList');
const RadarList = () => import('@/views/Admin/RadarList');
const BlobSuggestions = () => import('@/views/Admin/BlobSuggestions');
// const RadarView = () => import('@/components/radar/RadarView')

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   redirect: { name: 'dashboard' }
    // },
    {
      path: '/',
      redirect: { name: 'dashboard' }
    },
    {
      path: '/admin',
      component: Admin,
      props: true,
      // beforeEnter(to, from, next) {
      //   if(store.getters['user/isAdmin'])
      //     next();
      //   else
      //     next({ name: 'dashboard'})
      // },
      children: [
        {
          name: 'user-list',
          path: 'users',
          component: AdminUserList,
        },
        {
          name: 'radar-list',
          path: 'radars',
          component: RadarList
        },
        {
          name: 'suggestion-blobs',
          path: 'suggestion-blobs',
          component: BlobSuggestions
        },
        {
          name: 'admin',
          path: '',
        }
      ]
    },
    {
      name: 'dashboard',
      path: '/dashboard',
      component: Dashboard
    },
    {
      name: 'create-radar',
      path: '/radar/create',
      component: RadarCreator,
    },
    {
      path: '/radar/:radarId',
      component: Radar,
      props: true,
      children: [
        {
          path: 'b/:blobId',
          name: 'blob',
          component: Radar,
        },
        {
          name: 'radar',
          path: '',
        }
      ]
    },
    {
      path: '/info',
      component: Info,
      children: [
        {
          name: 'profile',
          path: 'profile',
          component: UserProfile
        },
        {
          name: 'terms',
          path: 'terms',
          component: Terms
        },
        {
          name: 'privacy',
          path: 'privacy',
          component: Privacy
        },
        {
          path: '',
          redirect: { name: 'profile' }
        }
      ]
    }
  ],
});

router.beforeEach((to, from, next) => {
  if(to.name === 'blob') {
    store.commit('blobs/setCurrentBlobId', to.params.blobId)
  }
  else if(to.name === 'radar') {
    store.commit('radars/setCurrentQuadrant', to.params.quadrantId ?? 4)
  }

  next();
});

export default router;
